import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { staticsUrl, baseUrl } from '../../../config';
import Player from './Player';
import PreloadImages from '../../../components/PreloadImages';
import historyCache from '../../../config/historyCache.json';
import dramaSounds from '../../../config/dramaSounds.json';

// eslint-disable-next-line
let soundEnabled = true;
function Drama(props) {
  const { media, exerciseProps } = props;
  const [status, setStatus] = useState('paused');
  const [thumbs, setThumbs] = useState([]);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);
  const [finishSent, setFinishSent] = useState(false);
  const [time, setTime] = useState(0);
  const [data, setData] = useState([]);

  useEffect(() => {
    const { playing, waiting, ended, pause, timeupdate } = media.events;
    const playingSubscription = playing.subscribe(() => setStatus('playing'));
    const loadingSubscription = waiting.subscribe(() => setStatus('loading'));
    const endedSubscription = ended.subscribe(() => setStatus('paused'));
    const pausedSubscription = pause.subscribe(() => setStatus('paused'));
    const timeupdateSubscription = timeupdate.subscribe(update);
    const partId = exerciseProps.part.id;
    const slidesObj = dramaSounds[partId];
    setData(slidesObj.data);
    if (!slidesObj) return;
    const audioPath = `${baseUrl}/resources/Drama/${slidesObj.url}`
    media.setUrl(audioPath);
    const exercise = exerciseProps?.exercise;
    if (!exercise) return;
    const images = exercise.map(r => r.imageUrl);
    const thumbs = [];
    images.forEach(img => {
      const preImg = historyCache[img];
      if (preImg) {
        const url = `${baseUrl}/resources/History/${preImg}`;
        if (thumbs.indexOf(url) === -1) thumbs.push(url);
      }
    });
    setThumbs(thumbs);
    play();
    return () => {
      playingSubscription.unsubscribe();
      loadingSubscription.unsubscribe();
      endedSubscription.unsubscribe();
      pausedSubscription.unsubscribe();
      timeupdateSubscription.unsubscribe();
      stop();
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (status === 'playing' && duration === 0) {
      const duration = media.getAudioDuration();
      setDuration(duration);
    }
    if (status === 'paused' && time && time === duration && !finishSent) {
      finishExercise();
    }
    // eslint-disable-next-line
  }, [status]);

  const finishExercise = () => {
    const { finishExercise, expand, onExpand } = exerciseProps;
    setFinishSent(true);
    media.finish();
    finishExercise();
    if (expand) {
      onExpand(false);
    }
  }

  const play = () => {
    if (!soundEnabled) return;
    media && media.play();
  }

  const stop = () => {
    media && media.stop();
  }

  const pause = () => {
    media && media.pause();
  }

  const setSoundEnabled = (val) => soundEnabled = val;

  const update = () => {
    setTime(media.getAudioTime());
  }

  return (
    <>
      <PreloadImages images={thumbs} onImgLoad={setProgress} />
      <Player
        play={play}
        stop={stop}
        pause={pause}
        status={status}
        {...exerciseProps}
        progress={progress}
        setSoundEnabled={setSoundEnabled}
        time={time}
        media={media}
        data={data}
      />
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    config: state.config,
    media: state.media,
    course: state.course,
  };
}

export default connect(mapStateToProps)(Drama);
